
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class NebulaGlowEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const clouds = Math.floor(8 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
            for (let i = 0; i < clouds; i++) {
                const rx = (this.pseudoRandom(i) - 0.5) * width * 2;
                const ry = (this.pseudoRandom(i + 1) - 0.5) * height * 2;
                const r = (300 + this.pseudoRandom(i + 2) * 300) * scale * (1 / (layerIndex + 1));
                
                // Pulsating drift
                const dx = Math.sin(curTime * 0.2 + i) * 100;
                const dy = Math.cos(curTime * 0.2 + i) * 100;
                
                const grad = ctx.createRadialGradient(rx + dx, ry + dy, 0, rx + dx, ry + dy, r);
                grad.addColorStop(0, pc.color);
                grad.addColorStop(1, 'transparent');
                
                ctx.save();
                ctx.globalAlpha *= 0.15;
                ctx.fillStyle = grad;
                ctx.beginPath();
                ctx.arc(rx + dx, ry + dy, r, 0, Math.PI * 2);
                ctx.fill();
                ctx.restore();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
